import * as React from 'react';
import { Manager, Popper, Target } from 'react-popper';
import * as PopperJS from 'popper.js';
import Menu, { MenuItem } from './base/Menu';

export interface IDropdownItem {
  key: string;
  component: JSX.Element;
}

export interface IDropdownProps {
  triggerComponent: JSX.Element;
  items: IDropdownItem[];
  onChange: (e: React.SyntheticEvent<HTMLElement>, selectedKey: string) => void;
  placement?: PopperJS.Placement;
}

interface IDropdownState {
  isOpen: boolean;
}

class Dropdown extends React.PureComponent<IDropdownProps, IDropdownState> {
  constructor(props: any) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.openMenu = this.openMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.stopPropagation = this.stopPropagation.bind(this);
  }

  public openMenu() {
    this.setState({ isOpen: true });
    window.addEventListener('click', this.closeMenu);
  }

  public closeMenu() {
    this.setState({ isOpen: false });
    window.removeEventListener('click', this.closeMenu);
  }

  public toggleMenu(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    if (this.state.isOpen) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  public selectItem(selectedItemKey: string, e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
    this.props.onChange(e, selectedItemKey);
    this.closeMenu();
  }

  public stopPropagation(e: React.MouseEvent<HTMLElement>) {
    e.stopPropagation();
  }

  public render() {
    return (
      <Manager onClick={this.stopPropagation} style={{ position: 'relative' }}>
        <Target onClick={this.toggleMenu} style={{ position: 'relative' }}>
          {this.props.triggerComponent}
        </Target>
        <Popper placement={this.props.placement}>
          <Menu isOpen={this.state.isOpen}>
            {this.props.items.length > 0 ? (
              this.props.items.map(item => (
                <MenuItem key={item.key} onClick={this.selectItem.bind(this, item.key)}>
                  {item.component}
                </MenuItem>
              ))
            ) : (
              <MenuItem key={0} disabled>
                他にアイテムはありません
              </MenuItem>
            )}
          </Menu>
        </Popper>
      </Manager>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/Dropdown.tsx